import { REQUEST_ATTEMPT_DEFAULT as Ae } from "../common/constants.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
const D = {
  _s: {
    Ka: "data",
    Xs: "content_cards/sync",
    Ri: "feature_flags/sync",
    Tr: "template",
  },
  ku: (t) => (null == t ? void 0 : t.j(o.C.lE)),
  sm: (t) => (null == t ? void 0 : t.j(o.C.SE)),
  nm: (t, e) => {
    null == t || t.I(o.C.lE, e);
  },
  um: (t, e) => {
    null == t || t.I(o.C.SE, e);
  },
  Wa: (t, e) => {
    if (!t || !e) return -1;
    const s = D.ku(t);
    if (null == s) return -1;
    const n = s[e];
    return null == n || isNaN(n) ? -1 : n;
  },
  Ya: (t, e) => {
    let s = Ae;
    if (!t || !e) return s;
    const n = D.sm(t);
    return null == n ? s : ((s = n[e]), null == s || isNaN(s) ? Ae : s);
  },
  Hs: (t, e, s) => {
    if (!t || !e) return;
    let n = D.ku(t);
    null == n && (n = {}), (n[e] = s), D.nm(t, n);
  },
  Ws: (t, e, s) => {
    if (!t || !e) return;
    let n = D.sm(t);
    null == n && (n = {}), (n[e] = s), D.um(t, n);
  },
  ti: (t, e) => {
    if (!t || !e) return;
    const s = D.Ya(t, e);
    D.Ws(t, e, s + 1);
  },
};
export default D;
